module.exports = "<div layout class=\"slider\">\n  <div flex=\"30\" layout layout-align=\"center center\">\n    <span class=\"md-caption\">{{slider.caption}}</span>\n  </div>\n  <md-slider flex min=\"{{slider.min}}\" max=\"{{slider.max}}\" ng-model=\"slider.ngModel\">\n  </md-slider>\n  <div flex=\"15\" layout layout-align=\"center center\">\n    <input ng-model=\"slider.inputModel\" />\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/slider/slider.html
// module id = 425
// module chunks = 0